import { User } from "./user"

export class UserValues {
    private _mp = new Map<string, Set<string>>();

    constructor(public user: User, public parentId: string,
        params: { [k: string]: string[] }) {
        Object.entries(params).forEach(([k, idLs]) => {
            idLs.forEach(id => {
                let s = this._mp.get(id)
                if (!s) {
                    s = new Set<string>()
                    this._mp.set(id, s)
                }
                s.add(k)
            })
        })

    }


    summary(itmId: string) {
        const bt = this.user.coords.binaryTree$.getTree(this.parentId)
        const resp = this._mp.get(itmId)
        if (!resp) return
        return {
            user: this.user,
            bt: bt,
            activeNodeSet: resp
        }
    }
}
